import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { ApiKeyEntity } from './api-key.entity';
import { BaseEntity } from './base.entity';
import { RbacRoleEntity } from './rbac-role.entity';

@Index('fk_api_key__id', ['fkApiKeyId'], {})
@Index('fk_rbac_role__id', ['fkRbacRoleId'], {})
@Index('unique_api_key_role', ['fkApiKeyId', 'fkRbacRoleId'], { unique: true })
@Entity('_rbac_role__api_key')
export class RbacRoleApiKeyEntity extends BaseEntity {
	@Column('int', { name: '_fk_api_key__id', unsigned: true })
	public fkApiKeyId!: number;

	@Column('int', { name: '_fk__rbac_role__id', unsigned: true })
	public fkRbacRoleId!: number;

	@ManyToOne(() => ApiKeyEntity, (apiKey) => apiKey.rbacRoles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_api_key__id', referencedColumnName: 'id' }])
	public apiKey!: ApiKeyEntity;

	@ManyToOne(() => RbacRoleEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__rbac_role__id', referencedColumnName: 'id' }])
	public rbacRole!: RbacRoleEntity;
}
